import React from 'react';
import { Toaster } from 'react-hot-toast';
import './i18n';
import { AuthProvider } from './contexts/AuthContext';
import { LanguageProvider } from './contexts/LanguageContext';
import { ErrorProvider } from './contexts/ErrorContext';
import { PaymentSettingsProvider } from './contexts/PaymentSettingsContext';
import { FavoritesProvider } from './contexts/FavoritesContext';
import { CartProvider } from './contexts/CartContext';
import AppRouter from './router';
import ErrorBoundary from './components/common/ErrorBoundary';
import NetworkStatus from './components/common/NetworkStatus';

function App() {
  return (
    <LanguageProvider>
      <AuthProvider>
        <PaymentSettingsProvider>
          <ErrorProvider>
            <FavoritesProvider>
              <CartProvider>
                <div className="App">
                  <ErrorBoundary>
                    <AppRouter />
                  </ErrorBoundary>
                  <NetworkStatus />
                  <Toaster
                position={document?.documentElement?.dir === 'rtl' ? 'top-left' : 'top-right'}
                toastOptions={{
                  duration: 4000,
                  style: {
                    background: '#363636',
                    color: '#fff',
                  },
                  success: {
                    duration: 3000,
                    iconTheme: {
                      primary: '#10B981',
                      secondary: '#fff',
                    },
                  },
                  error: {
                    duration: 5000,
                    iconTheme: {
                      primary: '#EF4444',
                      secondary: '#fff',
                    },
                  },
                }}
              />
                </div>
              </CartProvider>
            </FavoritesProvider>
          </ErrorProvider>
        </PaymentSettingsProvider>
      </AuthProvider>
    </LanguageProvider>
  );
}

export default App;
